import { Injectable } from '@angular/core';
import {
    CanActivate,
    CanLoad,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PartnerParametersService } from '../partner-parameters.service';

@Injectable()
export class PartnerParametersScanFlowGuardService implements CanLoad, CanActivate {
    constructor(
        private partnerService: PartnerParametersService,
        private router: Router,
    ) { }

    public canActivate(): Observable<boolean> {
        return this.canLoad();
    }

    public canLoad(): Observable<boolean> {
        return this.partnerService
            .checkUserPermissionToScanFlowManagement()
            .pipe(
                map((allowed: boolean) => {
                    if (!allowed) {
                        this.router.navigate(['page-forbidden']);
                    }

                    return allowed;
                }));
    }
}
